export enum MixpanelToken{
  PRODUCTION = <any>'e089d6c7c158db4aa97a52e2aeaf470d',
  TEST = <any>'d6cc1c868bef28d99e6c10a7e593442c'
}
